import { useQuery } from "react-query";
import { getProgressiveCodes } from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";

export const useGetProgressiveCodes = () => {
  return useQuery("GetProgressiveCodes", getProgressiveCodes, {
    refetchOnWindowFocus: false,
  });
};
